<template>
  <div class="width100" :class="['Padding', { inApp: $root.$data.isApp }]">
    <common-title titleName="过期课程" :bcColor="'#FEFEFF'" :zIndex="1000">
      <div slot="btnSty">
        <div class="courseBtn" v-if="overdueCourses.length>0" @click="eliminate">清除</div>
      </div>
    </common-title>
    <ul class="myCourse">
      <li v-for="item in overdueCourses" :key="item.id">
        <h3 class="ellipsis">{{item.productName}}</h3>
        <p>已过期</p>
      </li>
    </ul>
    <!-- 清除 -->
    <div>

    </div>
    <Foot/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqCourseList, delOverdueCourses } from '@/api/personal';
import Foot from '@/components/foot/privacy.vue';

export default {
  components: {
    Foot,
  },
  data() {
    return {
      overdueCourses: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    userInfo: {
      deep: true,
      handler() {
        this.getCourseList();
      },
    },
  },
  created() {},
  mounted() {
    this.getCourseList();
  },
  methods: {
    async getCourseList() { // 获取课程信息
      const userId = this.userInfo.id;
      if (userId) {
        const res = await reqCourseList([3], [1]);
        if (res.code === 0) {
          this.overdueCourses = res.data;// 过期课程列表
        }
      }
    },
    eliminate() {
      this.$dialog.confirm({
        title: '提示',
        message: '确认清除过期课程？',
      })
        .then(async () => {
          const res = await delOverdueCourses();
          if (res.code === 0) {
            this.getCourseList();
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot{
    position: fixed;
}
.courseBtn{
  position: absolute;
  top: 0;
  right: 36px;
  color: #333;
  font-size: 25px;
}
.Padding{
    padding-top: 100px;
    background: #F9F9F9FF;
    &.inApp{
      padding-top: 0;
    }
  }
  .myCourse{
    margin-top: 36px;
    padding-bottom:1px ;
    li{
      width: 678px;
      height: 170px;
      margin:0 auto 22px;
      padding: 36px 36px 0;
      background: #FFF;
      border-radius: 14px;
      h3{
        color: #333;
        font-size: 29px;
        line-height: 40px;
      }
      p{
        margin-top: 22px;
        color: #787878;
        font-size: 25px;
        line-height: 36px;
        span{
          color: #FF6C02;
        }
      }
    }
  }
</style>
